const $ = jQuery.noConflict()

// Require utilities
require('./utility/object-entries.js')
require('./utility/request-timeout.js')
require('./utility/done-typing.js')
require('./utility/tabbing.js')

var Cookie = require('./utility/cookie.js')
var LazyLoad = require('./utility/lazy-load.js')
var ReadMore = require('./components/read-more.js')
var Calculators = require("./components/calculators.js");

// Require jquery extend modules
var Header = require('./modules/header.js')
var Footer = require('./modules/footer.js')
var Nav = require('./modules/nav.js')
var NavBurger = require('./modules/nav-burger.js')
var PropertySearch = require('./modules/property-search.js')
var Statement = require('./modules/statement.js')
var Process = require('./modules/process.js')
var Valuation = require("./modules/valuation.js");

// Require jquery extend plugins
var Accordion = require('./plugins/accordion.js')
var Arrive = require('./plugins/arrive.js')
var AutoComplete = require('./plugins/autocomplete.google.js')
var Calculator = require('./plugins/calculator.js')
var Collapse = require('./plugins/collapse.js')
var Copy = require('./plugins/copy.js')
var CountdownTimer = require('./plugins/countdown-timer.js')
var Fetch = require('./plugins/fetch.ajax.js')
var Form = require('./plugins/form.js')
var FormStaged = require('./plugins/form-staged.js')
var Locrating = require('./plugins/locrating.js')
var Maps = require('./plugins/maps.google.js')
var MatchHeight = require('./plugins/match-height.js')
var MatchRow = require('./plugins/match-row.js')
var Modal = require('./plugins/modal.js')
var DateField = require('./plugins/date.js')
var Duplicate = require('./plugins/duplicate.js')
var Print = require('./plugins/print.js')
var ProxyField = require('./plugins/proxy.js')
var Reviews = require('./plugins/reviews.ajax.js')
var Save = require('./plugins/save.js')
var Scroll = require('./plugins/scroll.js')
var SideScroll = require('./plugins/side-scroll.js')
var Share = require('./plugins/share.js')
var Slider = require('./plugins/slider.slick.js')
var StatCounter = require('./plugins/stat-counter.js')
var Streets = require('./plugins/streetview.google.js')
var Submit = require('./plugins/submit.js')
var Tabs = require('./plugins/tabs.js')
var Toggle = require('./plugins/toggle.js')
var TextToggle = require('./plugins/text-toggle.js')
var Tooltip = require('./plugins/tooltip.js')
var Validation = require('./plugins/validation.js')
var Freeze = require("./plugins/freeze.js");
var YTplayer = require("./plugins/ytplayer.js");
var EnquiryType = require('./plugins/contact-enquiry-type.js');

// Require jquery extend plugins with ajax
var BranchFinder = require('./plugins/branch-finder.ajax.js')
var CraftyClicks = require('./plugins/craftyclicks.ajax.js')
var Search = require('./plugins/search.ajax.js')

// Document ready event - executes when HTML-Document is loaded and DOM is ready
$(document).on('ready', function () {
  // Restart videos
  $('video').on('ended', function () {
    this.load()
    this.play()
  })

  // Initialisers
  Header.init('#header')
  Footer.init('#footer')
  Collapse.init('.menu-item-has-children > a')
  Collapse.init('[data-collapse]')
  Copy.init('[data-copy]')
  CountdownTimer.init('.countdown-time')
  Print.init('[data-print]')
  ProxyField.init('[data-proxy]')
  Scroll.init('[data-scroll]')
  SideScroll.init('[data-sidescroll]')
  StatCounter.init('[data-stat]')
  Process.init(".process__tab");
  Toggle.init('[data-toggle]')
  Share.init('.btn-share')
  Slider.init('.slick')
  Maps.init('.map')
  Streets.init('.street')
  Form.init('.ttf-form')
  FormStaged.init('.form-staged')
  Nav.init('.nav__close')
  NavBurger.init('.nav__burger')
  Nav.init('.header__toggle')
  PropertySearch.init('.property-search')
  CraftyClicks.init('[data-craftyclicks]')
  ReadMore.init('[href="#read-more"]')
  LazyLoad.init('[data-src]')
  AutoComplete.init('[data-autocomplete]')
  BranchFinder.init('[data-branch-finder]')
  Tabs.init('[data-tab]')
  $(".statement__title--tab").statementContent();
  YTplayer.init()
  EnquiryType.init(); 

  Arrive.init()
  //plugin freeze
  Freeze.init("[data-freeze]");

  Valuation.init()

  // Window resize event
  $(window).on('resize', function () {
    Header.init('#header')
    Footer.init('#footer')
    MatchHeight.init('[data-match-height]')
    MatchRow.init('[data-match-row]')
  })

  // Window scroll event
  $(window).on('scroll', function () {
  }).trigger('scroll')

  // Custom triggers
  //
  // Maps
  $(document).on('mapShown', {}, function (event) {
    Maps.init('.map')
  })

  // Slick
  $(document).on('slickInit', {}, function (event, slick) {
    Slider.init('.slick')
  })

  // Cookie
  $(document).on('cookieStore', {}, function (event, name, value) {
    Cookie.store(name, value, 3600 * 1000 * 24 * 365)
  })

  // Header link hotfix
  $(document).on('click', '.header__nav li', function () {
    $('.header__nav li').not($(this)).each(function () {
      $(this).removeClass('show')
    })
  })
})

// Window load event - executes when complete page is fully loaded, including all frames, objects and images
$(window).on('load', function () {
  MatchHeight.init('[data-match-height]')
  MatchRow.init('[data-match-row]')
  Modal.init('.modal')
  Calculator.init('[data-calculator]')
  Fetch.init('[data-fetch]')
  Search.init('[data-search]')
  Submit.init('[data-submit]')
  TextToggle.init('[data-text]')
  Validation.init('[data-validate]')
  Accordion.init('.accordion')
  Save.init('[data-save]')
  Reviews.init('.reviews')
  Tooltip.init('.tooltip')
  Locrating.init('.locrating')
  Duplicate.init('[data-duplicate]')
  DateField.init('[data-date]')
})

// video autoplay
if($('#autoplay-video').length){
   setTimeout(function(){
    var myVideo = document.getElementById("autoplay-video");
     myVideo.play(); 
  }, 3000);
}




// Fixed property search bar
$(document).ready(function(){
  var elementOffset = $('.property-search-wrapper #property-search').offset().top;
  var elementHeight = $('.property-search-wrapper #property-search').height();

  // Window resize
  $(window).on('resize', function(){
    elementOffset = $('.property-search-wrapper #property-search').offset().top;
    elementHeight = $('.property-search-wrapper #property-search').height();
  });

  // Window scroll
   $(window).bind('scroll', function() {
    if($(window).width() > 767){
       var scrollTop = $(window).scrollTop();
       if(scrollTop > elementOffset - elementHeight){
         $(".property-search-wrapper #property-search").addClass("fixed");
       }else{
         $(".property-search-wrapper #property-search").removeClass("fixed");
       }

    }else{
      $(".property-search-wrapper #property-search").removeClass("fixed");
    }

   });
});